import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ImgSanity } from '@slite/components'

import type { TeamPersonData } from './+data'
import { SectionTitle } from './SectionTitle'

export const AboutSectionTeam = ({
  teamPeople,
  className,
}: {
  teamPeople: TeamPersonData[]
  className?: string
}) => {
  return (
    <div className={className}>
      <SectionTitle>
        <FormattedMessage id="about.page.team" defaultMessage={'Team'} />
      </SectionTitle>
      <div className="grid-12 grid-gap-32 grid-gap-16-small">
        {teamPeople.map((person) => (
          <div
            className="grid-span-3 grid-span-4-medium grid-span-4-small"
            key={person._id}
          >
            <ImgSanity
              src={person.profilePicture.url}
              alt={person.name}
              className="radius-larger margin-bottom-8"
            />
            <h5 className="font-family-title font-weight-medium font-size-6 margin-bottom-2">
              {person.name}
            </h5>
            <p className="font-size-7 shade-20">{person.position}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
